var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"inbound-shipment-inv-bundles","title":_vm.title},on:{"show":_vm.resetModal,"hidden":_vm.resetModal,"shown":_vm.shown}},[_c('b-row',{staticClass:"table-responsive"},[_c('b-table',{attrs:{"items":_vm.bundles,"fields":_vm.headers,"responsive":"sm","primary-key":"id","striped":"","small":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }